import MultipleChoiceQuestionPage from '@app-studio-web/ui/pages/MultipleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🍳',
    title: 'pages.onboarding.topicsQuestion.answer1',
  },
  {
    emoji: '✈️',
    title: 'pages.onboarding.topicsQuestion.answer2',
  },
  {
    emoji: '💼',
    title: 'pages.onboarding.topicsQuestion.answer3',
  },
  {
    emoji: '💻',
    title: 'pages.onboarding.topicsQuestion.answer4',
  },
  {
    emoji: '⚽',
    title: 'pages.onboarding.topicsQuestion.answer5',
  },
  {
    emoji: '🎨',
    title: 'pages.onboarding.topicsQuestion.answer6',
  },
  {
    emoji: '🔬',
    title: 'pages.onboarding.topicsQuestion.answer7',
  },
  {
    emoji: '👗',
    title: 'pages.onboarding.topicsQuestion.answer8',
  },
  {
    emoji: '🧘',
    title: 'pages.onboarding.topicsQuestion.answer9',
  },
  {
    emoji: '🤔',
    title: 'pages.onboarding.topicsQuestion.answer10',
  },
]

export default function TopicsQuestionPage() {
  return (
    <MultipleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.topicsQuestion.title"
      subtitle="pages.onboarding.topicsQuestion.subtitle"
    />
  )
}
